module.exports = {
      id: "google-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "svg-sprite-b468923450c663eeca769f8899a6b186.svg#google",
      toString: function () {
        return this.url;
      }
    }